module.exports = __webpack_public_path__ + "static/media/Sinikka1.6445ddc3.jpg";